import type { FaireProductEntity } from "../../entity_types/product";

export const p_ugrkmaxp4f: FaireProductEntity = {
  token: "p_ugrkmaxp4f",
  type: "product",
  name: "Om Vibration Comfy Waist Rayon and Cotton Flare Pants",
  brandToken: "b_5xdelgfsdc",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4c4c9e2ada3acfa0741933af24bc67a740053747d34869f9c10e085e13ecfa4c.jpeg",
  galleryImageUrls: [],
  priceDollars: 20.09,
  description:
    'Get ready to tune into the cosmic frequencies and embrace the groovy vibes with our "Om Vibration Comfy Waist Rayon and Cotton Flare Pants." Handcrafted with love and care in the enchanting land of Nepal, these pants are a true testament to the artisanal skills and rich cultural heritage of the region. The combination of soft rayon and breathable cotton creates a heavenly blend that feels like a gentle caress against your skin. The comfy waistband ensures a perfect fit for everyone, as these pants are designed to be one size fits all. Whether you\'re practicing yoga, dancing at a music festival, or simply lounging around, these pants will keep you feeling free and comfortable. The vibrant and mesmerizing Om Vibration print adds a touch of spiritual energy and positive vibrations to your every move. Allow the flared silhouette to flow with the rhythm of your steps, creating a captivating visual spectacle that reflects your inner peace and harmony. \n\nComes Assorted\n',
  tags: [],
  msrpDollars: 40.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:39.568Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
